export default __webpack_public_path__ + "static/media/Zombie.715f0a6e.jpg";